<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Index from "./components/Index";
export default {
  name: "App",
  // data() {
  //   return {
  //     excludeRouterName: []
  //   }
  // },
  components: {
    Index
  },
  watch:{
    '$route':{
      handler(to,from){
        const ua = navigator.userAgent.toLowerCase();
        if(to.meta.title){
          document.title=to.meta.title
        }
        if(ua.match(/MicroMessenger/i) == "micromessenger" && to.name.indexOf('CommonQuestion') < 0 && to.name.indexOf('NewsDetail') < 0) {
          WeixinJSBridge.call('hideOptionMenu'); //隐藏右上角三个点按钮。
          let _href=window.location.origin+to.fullPath
          this.$weChat.share((to.meta && to.meta.title) || document.title, _href)
        } else {
          sessionStorage.setItem('routerUri', window.location.origin+to.fullPath)
        }
        //  if(to.meta.keepAlive && to.meta.keepAliveChange) {
        //   this.excludeRouterName.push(to.name)
        //   this.$nextTick(_ => {
        //     this.excludeRouterName.pop()
        //   })
        // }
      }
    },
  },
  // computed: {
  //     exclude () {
  //       return this.excludeRouterName.join(',')
        
  //     }
  //   },
};
</script>

<style>
#app {
  font-family: 'Microsoft Yahei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* padding-bottom: 64px; */
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue